import type * as QueryRepository from "@/components/features/invoice-system-settings/model/repository/query";

export const serverModelToInputModelConverter = (serverModel: QueryRepository.ServerModel) => {
	const { invoiceSystemSettings } = serverModel;
	return {
		...invoiceSystemSettings,
		registrationCode: invoiceSystemSettings.registrationCode && invoiceSystemSettings.registrationCode.slice(1), // 接頭辞に T が付与されているため、InputModel では除去する
	};
};
